import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-298a1470"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "resume_layout_item" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "resume_title" }, "希望条件", -1))
const _hoisted_3 = { class: "resume_item" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "希望業種", -1))
const _hoisted_5 = { class: "resume_item_value" }
const _hoisted_6 = { class: "resume_item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "希望職種", -1))
const _hoisted_8 = { class: "resume_item_value" }
const _hoisted_9 = { class: "resume_item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "希望勤務地", -1))
const _hoisted_11 = { class: "resume_item_value" }
const _hoisted_12 = { class: "resume_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "希望年収", -1))
const _hoisted_14 = { class: "resume_item_value" }
const _hoisted_15 = { class: "resume_item_value_text" }
const _hoisted_16 = { class: "resume_item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "転職希望時期", -1))
const _hoisted_18 = { class: "resume_item_value" }
const _hoisted_19 = { class: "resume_item_value_text" }
const _hoisted_20 = { class: "resume_item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "希望雇用形態", -1))
const _hoisted_22 = { class: "resume_item_value" }
const _hoisted_23 = {
  key: 0,
  class: "resume_item_value_text"
}
const _hoisted_24 = {
  key: 1,
  class: "resume_item_value_text"
}
const _hoisted_25 = { class: "resume_item" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "resume_item_title" }, "ご希望条件の詳細", -1))
const _hoisted_27 = { class: "resume_item_value" }
const _hoisted_28 = { class: "resume_item_value_text" }
const _hoisted_29 = { class: "resume_button is-border-bottom-none" }
const _hoisted_30 = { class: "resume_button_inner" }

import { ref, Ref, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import BaseButton from '@/components/BaseButton.vue';
import { DesiredCondition } from '@/types';
import store from '@/store';

export default /*#__PURE__*/_defineComponent({
  __name: 'Desired',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const desiredCondition: Ref<DesiredCondition> = ref(store.getters['careerSheetDesired/desiredCondition']);
const mstIndsctgFlat = computed(() => store.getters['master/mstIndsctgFlat']);
const mstOcupClassFlat = computed(() => store.getters['master/mstOcupClassFlat']);
const mstListPrefOptions: Ref<{ label: string; value: number }[]> = computed(() => store.getters['master/mstListPrefOptions']);
const mstWishJobChangeDateId: Ref<{ code: number; name: string }[]> = computed(() =>
  store.getters['master/mstWishJobChangeDateId']);

const wishIndsctgNames: Ref<string[]> = computed(() => {
  const res = [];
  if (desiredCondition.value.wishIndsctg1Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg1Id]);
  }
  if (desiredCondition.value.wishIndsctg2Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg2Id]);
  }
  if (desiredCondition.value.wishIndsctg3Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg3Id]);
  }
  if (desiredCondition.value.wishIndsctg4Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg4Id]);
  }
  if (desiredCondition.value.wishIndsctg5Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg5Id]);
  }
  if (desiredCondition.value.wishIndsctg6Id) {
    res.push(mstIndsctgFlat.value[desiredCondition.value.wishIndsctg6Id]);
  }
  return res;
});
const wishOcupctgNames: Ref<string[]> = computed(() => {
  const res: string[] = [];
  if (desiredCondition.value.wishOcupctg1Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg1Id]);
  }
  if (desiredCondition.value.wishOcupctg2Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg2Id]);
  }
  if (desiredCondition.value.wishOcupctg3Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg3Id]);
  }
  if (desiredCondition.value.wishOcupctg4Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg4Id]);
  }
  if (desiredCondition.value.wishOcupctg5Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg5Id]);
  }
  if (desiredCondition.value.wishOcupctg6Id) {
    res.push(mstOcupClassFlat.value[desiredCondition.value.wishOcupctg6Id]);
  }
  return res;
});
const wishWkareaNames: Ref<string[]> = computed(() => {
  const nameArray: string[] = [];
  if (desiredCondition.value.wishWkarea1Id) {
    const wishWkarea1Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea1Id))[0]?.label || '';
    if (wishWkarea1Name) {
      nameArray.push(wishWkarea1Name);
    }
  }
  if (desiredCondition.value.wishWkarea2Id) {
    const wishWkarea2Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea2Id))[0]?.label || '';
    if (wishWkarea2Name) {
      nameArray.push(wishWkarea2Name);
    }
  }
  if (desiredCondition.value.wishWkarea3Id) {
    const wishWkarea3Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea3Id))[0]?.label || '';
    if (wishWkarea3Name) {
      nameArray.push(wishWkarea3Name);
    }
  }
  if (desiredCondition.value.wishWkarea4Id) {
    const wishWkarea4Name =
      mstListPrefOptions.value.filter((i) => i.value === Number(desiredCondition.value.wishWkarea4Id))[0]?.label || '';
    if (wishWkarea4Name) {
      nameArray.push(wishWkarea4Name);
    }
  }
  return nameArray;
});
const wishJobChangeDateLabel = computed(() => {
  return (
    mstWishJobChangeDateId.value.find(
      (item) => item.code === desiredCondition.value.wishJobChangeDateId
    )?.name || ''
  );
});


// 希望条件_編集画面
const transitionEditDesiredPage = () => {
  if (route.query.ref === 'e') {
    router.push({ name: 'e41', query: { ref: 'e' } });
  } else {
    router.push({ name: 'e41' });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishIndsctgNames), (wishIndsctgName, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "resume_item_value_text",
            key: `${wishIndsctgName}_${index}`
          }, _toDisplayString(wishIndsctgName), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishOcupctgNames), (wishOcupctgName, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "resume_item_value_text",
            key: `${wishOcupctgName}_${index}`
          }, _toDisplayString(wishOcupctgName), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _hoisted_10,
      _createElementVNode("div", _hoisted_11, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wishWkareaNames), (wishWkareaName, index) => {
          return (_openBlock(), _createElementBlock("p", {
            class: "resume_item_value_text",
            key: `${wishWkareaName}_${index}`
          }, _toDisplayString(wishWkareaName), 1))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, _toDisplayString(desiredCondition.value.wishAnnualIncomeNum) + "万円", 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(wishJobChangeDateLabel)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_20, [
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        (desiredCondition.value.empTypeFlg1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_23, "正社員"))
          : _createCommentVNode("", true),
        (desiredCondition.value.empTypeFlg5)
          ? (_openBlock(), _createElementBlock("p", _hoisted_24, "契約社員"))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _hoisted_26,
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("p", _hoisted_28, _toDisplayString(desiredCondition.value.demand), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _createVNode(BaseButton, {
          theme: "secondary",
          onClick: transitionEditDesiredPage
        }, {
          default: _withCtx(() => [
            _createTextVNode("希望条件を変更する")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})